import React, { useContext } from "react";

import { validateGuid } from "../../utils/data-validation/validateGuid";
import { useAuthContext } from "../auth-provider";

import { ACSService } from "./services/ACSService";
import { APIService } from "./services/APIService";
import { ServiceContext, ServiceContainer } from "./ServiceContext";

export const ServiceContextProvider: React.FC<React.PropsWithChildren<any>> = ({
  children,
}) => {
  // Grab the tenantId from the URL parameters and pass it to API service
  const { tenantId } = useAuthContext();

  // Validate tid is GUID before passing to API service
  const apiService = new APIService(validateGuid(tenantId ?? ""));
  const serviceContainer: ServiceContainer = {
    acsService: new ACSService(apiService, validateGuid(tenantId ?? "")),
    apiService: apiService,
  };
  return (
    <ServiceContext.Provider value={serviceContainer}>
      {children}
    </ServiceContext.Provider>
  );
};

export const useServiceContext = () => useContext(ServiceContext);
